// extracted by mini-css-extract-plugin
export default {"formsection":"FormSection_formsection__75Em1","formsection__header":"FormSection_formsection__header__Or2qT"};